var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { colors, cssVarsThemed, typographyCss } from '@creditornot/cb-ingredients';
import { createCssVars, themedConfigToThemedAttrs } from '@creditornot/cb-utils';
import menuItemBaseStyle from './menuItemBaseStyle';
var variantConfigs = {
    black: {
        light: {
            bgHover: colors.pepper8,
            bgActive: colors.pepper12,
            color: colors.pepper100,
            colorDisabled: colors.pepper40,
            largeIconBg: colors.pepper8,
            subLabelColor: colors.pepper64,
            subLabelColorDisabled: colors.pepper28,
        },
        dark: {
            bgHover: colors.salt12,
            bgActive: colors.salt16,
            color: colors.salt100,
            colorDisabled: colors.salt48,
            largeIconBg: colors.salt12,
            subLabelColor: colors.salt72,
            subLabelColorDisabled: colors.salt36,
        },
    },
    grey: {
        light: {
            bgHover: colors.pepper8,
            bgActive: colors.pepper12,
            color: colors.pepper64,
            colorDisabled: colors.pepper40,
            largeIconBg: colors.pepper8,
            subLabelColor: colors.pepper64,
            subLabelColorDisabled: colors.pepper28,
        },
        dark: {
            bgHover: colors.salt12,
            bgActive: colors.salt16,
            color: colors.salt68,
            colorDisabled: colors.salt44,
            largeIconBg: colors.salt12,
            subLabelColor: colors.salt72,
            subLabelColorDisabled: colors.salt36,
        },
    },
    blue: {
        light: {
            bgHover: colors.wolt8,
            bgActive: colors.wolt12,
            color: colors.wolt100,
            colorDisabled: colors.wolt40,
            largeIconBg: colors.wolt8,
            subLabelColor: colors.pepper64,
            subLabelColorDisabled: colors.pepper28,
        },
        dark: {
            bgHover: colors.wolt12,
            bgActive: colors.wolt16,
            color: colors.wolt100,
            colorDisabled: colors.wolt44,
            largeIconBg: colors.wolt12,
            subLabelColor: colors.salt72,
            subLabelColorDisabled: colors.salt36,
        },
    },
    red: {
        light: {
            bgHover: colors.strawberry8,
            bgActive: colors.strawberry12,
            color: colors.strawberry100,
            colorDisabled: colors.strawberry40,
            largeIconBg: colors.strawberry8,
            subLabelColor: colors.pepper64,
            subLabelColorDisabled: colors.pepper28,
        },
        dark: {
            bgHover: colors.strawberry12,
            bgActive: colors.strawberry16,
            color: colors.strawberry100,
            colorDisabled: colors.strawberry44,
            largeIconBg: colors.strawberry12,
            subLabelColor: colors.salt72,
            subLabelColorDisabled: colors.salt36,
        },
    },
};
var variantCssVars = createCssVars([
    'bgHover',
    'bgActive',
    'color',
    'colorDisabled',
    'largeIconBg',
    'subLabelColor',
    'subLabelColorDisabled',
]);
var colorsConfig = {
    textSelected: {
        light: colors.salt100,
        dark: colors.space100,
    },
    textSelectedDisabled: {
        light: colors.salt80,
        dark: colors.space72,
    },
    largeIconBgSelected: {
        light: colors.salt8,
        dark: colors.pepper12,
    },
};
var commonColorCssVars = createCssVars([
    'textSelected',
    'textSelectedDisabled',
]);
var SubLabel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), typographyCss.Small);
export var IconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  svg {\n    width: 12px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  svg {\n    width: 12px;\n  }\n"])));
var LargeIconContainer = styled(IconContainer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: ", ";\n  svg {\n    width: 50%;\n  }\n"], ["\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: ", ";\n  svg {\n    width: 50%;\n  }\n"])), function (_a) {
    var $selected = _a.$selected;
    return $selected ? commonColorCssVars.largeIconBgSelected : variantCssVars.largeIconBg;
});
export var rootCss = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n\n  ", "\n  ", "\n\n  &[data-selected] {\n    font-weight: 700;\n  }\n\n  &[disabled]:not([data-selected]) {\n    &&,\n    &&:hover,\n    &&:active {\n      background-color: transparent;\n      color: ", ";\n      cursor: not-allowed;\n    }\n\n    ", " {\n      color: ", ";\n    }\n\n    svg {\n      fill: ", ";\n    }\n  }\n\n  &[data-selected][disabled] {\n    &&,\n    &&:hover,\n    &&:active {\n      background-color: ", ";\n      color: ", ";\n      cursor: not-allowed;\n\n      ", " svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  &[data-selected]:not([disabled]) {\n    background-color: ", ";\n    color: ", ";\n\n    &&:hover {\n      background-color: ", ";\n    }\n    &&:active {\n      background-color: ", ";\n    }\n\n    ", " svg {\n      fill: ", ";\n    }\n  }\n\n  &:not([disabled]):not([data-selected]) {\n    color: ", ";\n\n    ", " {\n      color: ", ";\n    }\n\n    &&:hover {\n      background-color: ", ";\n    }\n\n    &&:active {\n      background-color: ", ";\n    }\n\n    ", " svg {\n      fill: ", ";\n    }\n  }\n\n  &[data-highlighted]:not([data-selected]) {\n    background-color: ", ";\n  }\n"], ["\n  ", "\n\n  ", "\n  ", "\n\n  &[data-selected] {\n    font-weight: 700;\n  }\n\n  &[disabled]:not([data-selected]) {\n    &&,\n    &&:hover,\n    &&:active {\n      background-color: transparent;\n      color: ", ";\n      cursor: not-allowed;\n    }\n\n    ", " {\n      color: ", ";\n    }\n\n    svg {\n      fill: ", ";\n    }\n  }\n\n  &[data-selected][disabled] {\n    &&,\n    &&:hover,\n    &&:active {\n      background-color: ", ";\n      color: ", ";\n      cursor: not-allowed;\n\n      ", " svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  &[data-selected]:not([disabled]) {\n    background-color: ", ";\n    color: ", ";\n\n    &&:hover {\n      background-color: ", ";\n    }\n    &&:active {\n      background-color: ", ";\n    }\n\n    ", " svg {\n      fill: ", ";\n    }\n  }\n\n  &:not([disabled]):not([data-selected]) {\n    color: ", ";\n\n    ", " {\n      color: ", ";\n    }\n\n    &&:hover {\n      background-color: ", ";\n    }\n\n    &&:active {\n      background-color: ", ";\n    }\n\n    ", " svg {\n      fill: ", ";\n    }\n  }\n\n  &[data-highlighted]:not([data-selected]) {\n    background-color: ", ";\n  }\n"])), menuItemBaseStyle, cssVarsThemed(colorsConfig), function (_a) {
    var $variant = _a.$variant;
    return cssVarsThemed(themedConfigToThemedAttrs(variantConfigs[$variant]));
}, variantCssVars.colorDisabled, SubLabel, variantCssVars.subLabelColorDisabled, variantCssVars.colorDisabled, colors.wolt80, commonColorCssVars.textSelectedDisabled, IconContainer, commonColorCssVars.textSelectedDisabled, colors.wolt100, commonColorCssVars.textSelected, colors.wolt92, colors.wolt84, IconContainer, commonColorCssVars.textSelected, variantCssVars.color, SubLabel, variantCssVars.subLabelColor, variantCssVars.bgHover, variantCssVars.bgActive, IconContainer, variantCssVars.color, variantCssVars.bgHover);
var Root = styled.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), rootCss);
var LeftContent = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  margin-inline-end: 8px;\n  padding-inline-end: ", "px;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  margin-inline-end: 8px;\n  padding-inline-end: ", "px;\n"])), function (_a) {
    var $rightPadding = _a.$rightPadding;
    return $rightPadding;
});
var RightContent = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-inline-start: 8px;\n  flex: 0;\n"], ["\n  margin-inline-start: 8px;\n  flex: 0;\n"])));
var ContentContainer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
var Content = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
var MenuActionItem = forwardRef(function (_a, ref) {
    var children = _a.children, focused = _a.focused, icon = _a.icon, leftContent = _a.leftContent, rightContent = _a.rightContent, _b = _a.role, role = _b === void 0 ? 'menuitem' : _b, _c = _a.selected, selected = _c === void 0 ? false : _c, subLabel = _a.subLabel, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d, _e = _a.variant, variant = _e === void 0 ? 'black' : _e, rest = __rest(_a, ["children", "focused", "icon", "leftContent", "rightContent", "role", "selected", "subLabel", "tabIndex", "variant"]);
    return (React.createElement(Root, __assign({ "$variant": variant, "data-highlighted": focused ? true : undefined, "data-selected": selected ? true : undefined, role: role, tabIndex: tabIndex }, rest, { "data-cb-menu-item": true, ref: ref, type: "button" }),
        !!leftContent && React.createElement(LeftContent, { "$rightPadding": subLabel ? 4 : 0 }, leftContent),
        !leftContent && !!icon && (React.createElement(LeftContent, { "$rightPadding": subLabel ? 4 : 0 }, subLabel ? (React.createElement(LargeIconContainer, { "$selected": selected }, icon)) : (React.createElement(IconContainer, null, icon)))),
        React.createElement(ContentContainer, null,
            React.createElement(Content, null, children),
            !!subLabel && React.createElement(SubLabel, null, subLabel)),
        !!rightContent && React.createElement(RightContent, null, rightContent)));
});
MenuActionItem.displayName = 'MenuActionItem';
export default MenuActionItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=MenuActionItem.js.map